import { toBodyHtml, type GuideStep } from "../loadProjectOverviewGuideSteps";

// The key orderStepsForDeck sorts this card to the very end of the deck by.
export const REPLAY_GUIDE_KEY = "replay-guide";

// The last card every deck shows: a reminder that the ⓘ on the active nav row (SidebarNavItem.vue
// stamps it `${linkId}-guide`) replays the whole guide. Sorted past the deck's own ending row by
// orderStepsForDeck, and dropped entirely on an on-demand replay (WelcomeTour.vue's
// buildAnchoredSteps) since that run already started from the very button it points at.
export function replayGuideStep(linkId: string): GuideStep {
  return {
    id: "",
    key: REPLAY_GUIDE_KEY,
    anchorId: `${linkId}-guide`,
    title: "Come back any time",
    bodyHtml: toBodyHtml(
      "Every page's guide lives behind this ⓘ, on the row of the page you are on. One click replays it whenever you want a refresher."
    ),
    alreadySeen: false,
    highlight: true,
    firstRunOnly: true,
  };
}
